module.exports = __webpack_public_path__ + "img/FR30087.62ebfee5.png";